module.exports = __webpack_public_path__ + "static/media/wizualizacja-71.3b56a1c3.png";